import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const savedUser = localStorage.getItem('restaurant_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (pin) => {
    let role = null;
    let name = '';
    
    if (pin === '9999') {
      role = 'super_admin';
      name = 'Super Admin';
    } else if (pin === '1234') {
      role = 'manager';
      name = 'Manager';
    } else if (pin === '0000') {
      role = 'hostess';
      name = 'Hostess';
    }

    if (role) {
      const userData = { role, name, pin };
      setUser(userData);
      localStorage.setItem('restaurant_user', JSON.stringify(userData));
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('restaurant_user');
  };

  const hasAccess = (page) => {
    if (!user) return false;
    
    const permissions = {
      super_admin: ['dashboard', 'crm', 'analytics', 'marketing', 'logs', 'staff'],
      manager: ['dashboard', 'crm', 'analytics', 'marketing', 'logs'],
      hostess: ['dashboard']
    };

    return permissions[user.role]?.includes(page) || false;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, hasAccess, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
